/** Cross-component “open this support ticket” / create-ticket signals. */

export const SUPPORT_OPEN_EVENT = 'yp-support-open';
export const SUPPORT_CREATE_EVENT = 'yp-support-create';

const PENDING_OPEN_KEY = 'yp_portal_support_pending_open';

export type SupportOpenDetail = {
  ticketId: number;
  fresh?: boolean;
};

export function requestOpenSupportTicket(ticketId: number, fresh = true): void {
  if (!Number.isFinite(ticketId) || ticketId <= 0) return;
  try {
    sessionStorage.setItem(PENDING_OPEN_KEY, JSON.stringify({ ticketId, fresh }));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(
    new CustomEvent<SupportOpenDetail>(SUPPORT_OPEN_EVENT, {
      detail: { ticketId, fresh },
    }),
  );
}

export function takePendingSupportOpen(): SupportOpenDetail | null {
  try {
    const raw = sessionStorage.getItem(PENDING_OPEN_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(PENDING_OPEN_KEY);
    const parsed = JSON.parse(raw) as { ticketId?: unknown; fresh?: unknown };
    const ticketId = Number(parsed.ticketId ?? 0);
    if (!Number.isFinite(ticketId) || ticketId <= 0) return null;
    return { ticketId, fresh: parsed.fresh !== false };
  } catch {
    try {
      sessionStorage.removeItem(PENDING_OPEN_KEY);
    } catch {
      /* ignore */
    }
    return null;
  }
}

export function requestOpenSupportCreate(): void {
  try {
    sessionStorage.setItem('yp_portal_support_create', '1');
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(SUPPORT_CREATE_EVENT));
}

export function parseSupportOpenMessage(data: unknown): SupportOpenDetail | null {
  if (!data || typeof data !== 'object') return null;
  const row = data as { type?: string; ticketId?: unknown; ticket_id?: unknown };
  if (row.type !== 'support-open') return null;
  const ticketId = Number(row.ticketId ?? row.ticket_id ?? 0);
  if (!Number.isFinite(ticketId) || ticketId <= 0) return null;
  return { ticketId, fresh: true };
}
